import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "mt10 align-right" }

import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getStoreOrderDetailApi } from '@/apis/order'


export default /*@__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const route = useRoute()
const orderId = route.query.order_id as string

const orderData = ref<any>({})
const previewList = ref<any>([])

const closeOrder = () => {
    window.close()
}

onMounted(async () => {
    const { code, data, msg } = await getStoreOrderDetailApi(orderId) as any
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    data.show_name = data.username?.length == 11 ? data.username : data.name || '--'
    data.pay_info = `总额：${data.total_amount} 实付：${data.final_amount} 余额：${data.user_money_paid}`
    orderData.value = data
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: "",
      model: orderData.value,
      class: "demo-form-inline",
      "label-width": "100px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "三方订单号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.store_order_no,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderData.value.store_order_no) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "用户ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.user_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderData.value.user_id) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "订单号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.order_no,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((orderData.value.order_no) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "用户" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.show_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((orderData.value.show_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "品牌" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.store_brand_name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((orderData.value.store_brand_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "餐厅" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.store_name,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((orderData.value.store_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: orderData.value.items,
          border: "",
          style: {"width":"100%"},
          class: "mb20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "商品",
              prop: "goods_name"
            }),
            _createVNode(_component_el_table_column, {
              label: "规格",
              prop: "spec_name"
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              prop: "quantity",
              width: "80"
            }),
            _createVNode(_component_el_table_column, {
              label: "总计",
              prop: "total_sale_price",
              width: "80"
            }),
            _createVNode(_component_el_table_column, { label: "图片" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_image, {
                  onClick: ($event: any) => (previewList.value = [row.goods_image]),
                  src: row.goods_image,
                  "preview-src-list": previewList.value,
                  "preview-teleported": true,
                  style: {"width":"100px"}
                }, null, 8, ["onClick", "src", "preview-src-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "取餐号",
              prop: "takeCode"
            }),
            _createVNode(_component_el_table_column, {
              label: "取件尾号",
              prop: "orderPhone"
            }),
            _createVNode(_component_el_table_column, { label: "取餐码" }, {
              default: _withCtx(({ row }) => [
                (row.qrData)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `http://www.dangaoss.com/h5/qr/show?url=${row.qrData}`,
                      target: "_blank"
                    }, _toDisplayString(row.qrData), 9, _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_form_item, { label: "取餐方式" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: orderData.value.pack_flag,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((orderData.value.pack_flag) = $event)),
              disabled: "",
              placeholder: "请选择取餐方式"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "堂食",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "打包",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "外送",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "用户联系" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.receiver_phone,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((orderData.value.receiver_phone) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "收件人姓名" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.receiver_name,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((orderData.value.receiver_name) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "收件地址" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.receiver_address,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((orderData.value.receiver_address) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "订单金额" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: orderData.value.pay_info,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((orderData.value.pay_info) = $event)),
              row: 1,
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "下单时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.created_at,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((orderData.value.created_at) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "支付时间" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.paid_at,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((orderData.value.paid_at) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "订单状态" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: orderData.value.status,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((orderData.value.status) = $event)),
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "待支付",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "已支付",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "已完成",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "已取消",
                  value: 3
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "用户当前余额" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: orderData.value.totalMoney,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((orderData.value.totalMoney) = $event)),
              disabled: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, { class: "ml10" }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("余额日志")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, { onClick: closeOrder }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})